import { find } from "../utils/dom";
import Swiper from "swiper";

const PageQuemSomos = () =>{
	const page = find(`[js-page='quem-somos']`);
	if(!page) return;

	const $Swipers = {
		cronologia: find('.swiper-cronologia'),
		cronologiaBackground: find('.swiper-cronologia-background'),
	}

	const $ = {
		canvasRaio: find('#canvas-raio')
	}

	// Sai cedo se a cronologia não estiver nesta página (evita erro de Swiper/canvas nulos).
	if(!$Swipers.cronologia || !$.canvasRaio) return;

	const SwiperCronologia = new Swiper($Swipers.cronologia,{
		slidesPerView: 1,
		spaceBetween: 24,
		navigation:{
			nextEl: ".swiper-button-next-cronologia",
			prevEl: ".swiper-button-prev-cronologia"
		},
		pagination:{
			clickable: true,
			el: ".swiper-pagination-cronologia",
		},
		breakpoints:{
			767:{
				slidesPerView: 'auto',
				spaceBetween: 200,
			}
		}
	})

	const SwiperCronologiaBackground = new Swiper($Swipers.cronologiaBackground,{
		slidesPerView: 'auto',
		spaceBetween: 24
	})

	SwiperCronologia.controller.control = SwiperCronologiaBackground;
	SwiperCronologiaBackground.controller.control = SwiperCronologia;

	// ----- Contador "Sob custódia": evolui suavemente conforme o marco ativo -----
	// Valor por marco (R$ bilhões), na ordem dos slides. 0 => "—".
	const custodiaValores = [0, 0, 1, 1, 1, 1, 1, 2, 3, 3, 3, 3];
	const custEl = find('#cronologia-custodia');
	const fmtCustodia = (v) => {
		if (v < 0.05) return '—';
		const u = Math.round(v * 10) / 10;
		return 'R$ ' + (u % 1 === 0 ? String(u) : u.toFixed(1).replace('.', ',')) + ' bi';
	};
	let custodiaAtual = 0;
	let custodiaAlvo = custodiaValores[0] || 0;
	const atualizarAlvoCustodia = () => {
		const i = SwiperCronologia.activeIndex;
		if (i >= 0 && i < custodiaValores.length) custodiaAlvo = custodiaValores[i];
	};
	SwiperCronologia.on('slideChange', atualizarAlvoCustodia);
	atualizarAlvoCustodia();
	(function tickCustodia() {
		custodiaAtual += (custodiaAlvo - custodiaAtual) * 0.1;
		if (Math.abs(custodiaAlvo - custodiaAtual) < 0.01) custodiaAtual = custodiaAlvo;
		if (custEl) custEl.textContent = fmtCustodia(custodiaAtual);
		requestAnimationFrame(tickCustodia);
	})();

	const ctx = $.canvasRaio.getContext("2d");

	function sortearInteiro(min, max) {
		return Math.floor(Math.random() * (max - min + 1)) + min;
	}

	function desenharRaio(startX, startY, endX, endY){
    let x = startX;
    let y = startY;

    ctx.strokeStyle = "#ccab78";
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(x, y);


		for(let i = 1; i < endX; i++){
			if(i%4 == 0){
				ctx.lineTo(i, sortearInteiro(endY,endY+10));
			}
		}

    ctx.lineTo(endX,endY);
    ctx.stroke();
	}


	setInterval(()=>{
		ctx.clearRect(0, 0, $.canvasRaio.clientWidth, 100);
		desenharRaio(0, 50, $.canvasRaio.clientWidth, 50);
	}, 150)


	
}

export default PageQuemSomos;